/* Opens the desktop mega-menu on hover, in addition to the native click/keyboard
   toggle. Reuses the native `open` property so Dawn's existing open/close
   animation, positioning and z-index logic (details-disclosure.js) keeps working
   unchanged — this only decides *when* `open` flips, not how it renders. */
(function () {
  function isDesktop() {
    return window.matchMedia('(min-width: 990px)').matches;
  }

  function setOpen(details, open) {
    if (details.open === open) return;
    details.open = open;
    details.dispatchEvent(new Event('toggle'));
    var summary = details.querySelector(':scope > summary');
    if (summary) summary.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('header-menu > .mega-menu').forEach(function (details) {
      var closeTimer;

      details.addEventListener('mouseenter', function () {
        if (!isDesktop()) return;
        clearTimeout(closeTimer);
        setOpen(details, true);
      });

      details.addEventListener('mouseleave', function () {
        if (!isDesktop()) return;
        closeTimer = setTimeout(function () {
          setOpen(details, false);
        }, 150);
      });
    });
  });
})();
